import React from 'react'
import HeroSection from './homeComponents/HeroSection';
import HowSection from './homeComponents/HowSection';
import QouteSection from './homeComponents/QouteSection';
import StillSection from './homeComponents/StillSection';
import Features from './homeComponents/Features';
import FaqSection from './homeComponents/FaqSection.jsx';
import HealthTips from './homeComponents/HealthTips.jsx';
import PricingSection from './homeComponents/PricingSection.jsx';
import ReviewSection from './homeComponents/ReviewSection.jsx';

const Home = () => {

    return (
        <div className='flex items-center justify-center w-full flex-col'>

            <HeroSection />

            <hr className='mx-[5.8vw] border-[#EAECF0] max-w-[1980px] w-full' />

            <HowSection />

            <Features />

            <QouteSection />

            <HealthTips />

            <PricingSection/>
            
            {/* <ReviewSection/> */}

            <FaqSection />

            <StillSection />

        </div>
    )
}

export default Home;